module.exports = __webpack_public_path__ + "static/3-3-3c25f147c987790da997b7aec114e3a0.png";